module.exports = __webpack_public_path__ + "static/img/pro2.aa7a87d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro2.png
// module id = k+zF
// module chunks = 0